<!-- <div class="row my-3">
    <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
      <label for="ongoing-user-type">Auction Type</label>
      <select id="ongoing-user-type" class="form-control" name="userType" (change)="context.searchProductsFromList($event)">
        <option value="" disabled selected>Please select an auction type</option>
        <option *ngFor="let type of context.userType" [value]="type">{{ type }}</option>
      </select>
    </div>
    <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3 d-flex align-items-end"><button (click)="context.resetFilter()" class="btn btn__main2 curved fw-500">Reset</button></div>
  </div> -->
<div
  *ngIf="context.flag && context.activeTab === 'on-going' && context.showOnging"
  style="overflow: hidden"
>
  <p *ngIf="!context.tableData.length" class="m-0">No data found</p>
  <table
    datatable
    [dtOptions]="context.auctionTableDtOptions"
    class="row-border hover m-0 w-100"
  >
    <thead>
      <tr>
        <th *ngFor="let thead of context.auctionTheads">{{ thead }}</th>
      </tr>
    </thead>
    <tbody></tbody>
  </table>
</div>
